import React, { useMemo } from "react";
import useCloseBanner from "../hooks/use-close-banner";
import BannerPromoFragment from "./banner-promo-fragment";

const BannerPromo = ({ data }) => {
  const banners = useMemo(() => {
    return data
      .slice(0, 2)
      .map(({ id, liferayFields: { articleId }, promoExternalTitleFieldSet }) => {
        const {
          promoExternalTitle: title,
          promoType: promoTypes,
          promoInternalTitle: internalTitle,
          promoDescription: internalDescription,
          promoCtaLabelFieldSet: { promoCtaLabel: ctaLabel, promoCtaLink: ctaContent },
        } = promoExternalTitleFieldSet;
        return {
          id,
          articleId,
          title,
          promoType: promoTypes[0],
          internalTitle,
          internalDescription,
          ctaLabel,
          ctaContent,
        };
      });
  }, [data]);

  const storageKeys = useMemo(() => banners.map((banner) => banner.articleId), [banners]);

  const [hiddenItems, removeBanner] = useCloseBanner(storageKeys);

  return (
    <div className="banner-promo__wrapper">
      <div className="container-fluid">
        <div className="row d-flex flex-columns flex-md-row justify-content-center align-items-center">
          {banners
            .filter((item) => (hiddenItems ? !hiddenItems[item.articleId] : false))
            .map((item, i) => (
              <BannerPromoFragment
                item={item}
                itemLength={banners.length}
                closeBanner={removeBanner}
                key={i}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default BannerPromo;
